<script setup lang="ts">
import { toPascalCase } from '~/utils/format'
import { CategoryIcon } from '~/interfaces/UI'
import IconAirport from '../Icons/IconAirport.vue'
import IconAssociation from '../Icons/IconAssociation.vue'
import IconCampsite from '../Icons/IconCampsite.vue'
import IconCarDealership from '../Icons/IconCarDealership.vue'
import IconChurch from '../Icons/IconChurch.vue'
import IconCinema from '../Icons/IconCinema.vue'
import IconCompany from '../Icons/IconCompany.vue'
import IconHighway from '../Icons/IconHighway.vue'
import IconHospital from '../Icons/IconHospital.vue'
import IconHotel from '../Icons/IconHotel.vue'
import IconPark from '../Icons/IconPark.vue'
import IconParking from '../Icons/IconParking.vue'
import IconPerson from '../Icons/IconPerson.vue'
import IconPoint from '../Icons/IconPoint.vue'
import IconPublicRoads from '../Icons/IconPublicRoads.vue'
import IconRestaurant from '../Icons/IconRestaurant.vue'
import IconSchool from '../Icons/IconSchool.vue'
import IconServiceStation from '../Icons/IconServiceStation.vue'
import IconShop from '../Icons/IconShop.vue'
import IconStation from '../Icons/IconStation.vue'
import IconTownHall from '../Icons/IconTownHall.vue'
import IconUnknown from '../Icons/IconUnknown.vue'

const props = defineProps({
    category: {
        type: String,
        default: 'unknown'
    }
})

const icons = {
    IconAirport,
    IconAssociation,
    IconCampsite,
    IconCarDealership,
    IconChurch,
    IconCinema,
    IconCompany,
    IconHighway,
    IconHospital,
    IconHotel,
    IconPark,
    IconParking,
    IconPerson,
    IconPoint,
    IconPublicRoads,
    IconRestaurant,
    IconSchool,
    IconServiceStation,
    IconShop,
    IconStation,
    IconTownHall,
    IconUnknown
}

const iconName = computed(() => {
    const possibleIconName = `Icon${toPascalCase(props.category)}`

    if (
        Object.keys(icons).includes(possibleIconName) &&
        possibleIconName in CategoryIcon
    ) {
        return possibleIconName as CategoryIcon
    }

    return CategoryIcon.IconUnknown
})
</script>

<template>
    <div>
        <component :is="icons[iconName]" class="h-full" />
    </div>
</template>
